export default {"src":"/_next/static/media/cry.bf99c8ce.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};